import React, { useState } from 'react';
import { downloadAppleWalletPass, getAppleWalletSupportMessage } from '../utils/appleWallet';

interface AppleWalletButtonProps {
    hashedId: string;
    qrCode: string;
    orderId?: string;
    ticketIndex?: number;
    className?: string;
}

const AppleWalletButton: React.FC<AppleWalletButtonProps> = ({
    hashedId,
    qrCode,
    orderId,
    ticketIndex,
    className = ''
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleDownload = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const passData = {
                hashedId,
                qrCode,
                ...(orderId && ticketIndex !== undefined && { orderId, ticketIndex })
            };

            await downloadAppleWalletPass(passData);
        } catch (err) {
            console.error('Error downloading Apple Wallet pass:', err);
            setError(err instanceof Error ? err.message : 'Failed to download Apple Wallet pass');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={`flex flex-col items-center ${className}`}>
            <button
                onClick={handleDownload}
                disabled={isLoading}
                className={`flex items-center justify-center gap-2 px-3 h-9 rounded bg-white text-[#080808] text-sm font-medium border border-gray-200 hover:bg-gray-100 transition-colors ${isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            >
                {isLoading ? (
                    <>
                        <div className="w-4 h-4 border-2 border-[#080808] border-t-transparent rounded-full animate-spin"></div>
                        <span>Downloading...</span>
                    </>
                ) : (
                    <>
                        <svg
                            className="w-4 h-4"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                        </svg>
                        <span>{getAppleWalletSupportMessage()}</span>
                    </>
                )}
            </button>

            {error && (
                <div className="mt-2 text-xs text-red-500 text-center max-w-[200px]">
                    {error}
                </div>
            )}
        </div>
    );
};

export default AppleWalletButton;
